(function () {
  if (window.__voroPdpLoaded) return;
  window.__voroPdpLoaded = true;

  function q(root, sel) { return root.querySelector(sel) || document.querySelector(sel); }
  function qa(root, sel) { var n = root.querySelectorAll(sel); return n.length ? n : document.querySelectorAll(sel); }

  function bindRatingLink() {
    document.querySelectorAll('.vpdp__ratinglink').forEach(function (a) {
      if (a.getAttribute('data-vpdp-bound') === '1') return;
      a.setAttribute('data-vpdp-bound', '1');
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        e.stopPropagation();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
        if (top < 0) top = 0;
        try { window.scrollTo({ top: top, behavior: 'smooth' }); }
        catch (err) { window.scrollTo(0, top); }
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      }, true);
    });
  }

  function drawerOpensOnAdd() {
    return !!(document.getElementById('voro-cart-drawer') &&
              window.VORO_CART_CONFIG && window.VORO_CART_CONFIG.openOnAdd);
  }

  function bindGallery(gal) {
    var track = gal.querySelector('[data-vpdp-track]');
    if (!track) return null;
    var slides = track.querySelectorAll('.vpdp__slide');
    var n = slides.length;
    if (n < 2) return null;
    var thumbs = gal.querySelectorAll('.vpdp__thumb');
    var strip = gal.querySelector('[data-vpdp-thumbs]');
    var prev = gal.querySelector('[data-vpdp-gal-prev]');
    var next = gal.querySelector('[data-vpdp-gal-next]');
    var pos = gal.querySelector('[data-vpdp-gal-pos]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = -1, target = -1, targetTimer = 0, ticking = false;

    function pauseOthers(i) {
      slides.forEach(function (s, k) {
        if (k === i) return;
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
        var f = s.querySelector('iframe');
        if (f && f.contentWindow) {
          f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          f.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
    }

    function warm(i) {
      for (var k = i - 1; k <= i + 1; k++) {
        var im = slides[k] && slides[k].querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
      }
    }

    function keepThumbVisible(t) {
      if (!strip || !t) return;
      var left = t.offsetLeft, right = left + t.offsetWidth;
      if (left < strip.scrollLeft) strip.scrollTo({ left: left - 4, behavior: reduce ? 'auto' : 'smooth' });
      else if (right > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: right - strip.clientWidth + 4, behavior: reduce ? 'auto' : 'smooth' });
    }

    function mark(i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (pos) pos.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      keepThumbVisible(thumbs[i]);
      pauseOthers(i);
      warm(i);
    }

    function go(i) {
      i = Math.max(0, Math.min(n - 1, i));
      var smooth = !reduce && Math.abs(i - cur) === 1;
      target = i;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(function () { target = -1; }, 900);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      mark(i);
    }

    function onScroll() {
      ticking = false;
      var w = track.clientWidth;
      if (!w) return;
      var k = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
      if (target >= 0) {
        if (k !== target) return;
        target = -1;
      }
      mark(k);
    }

    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    track.addEventListener('scrollend', function () { target = -1; onScroll(); });

    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        go(k);
        var v = slides[k].querySelector('video');
        if (v && v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
    });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });

    gal.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target !== track && !e.target.classList.contains('vpdp__thumb')) return;
      e.preventDefault();
      go(cur + (e.key === 'ArrowRight' ? 1 : -1));
      if (e.target.classList.contains('vpdp__thumb') && thumbs[cur]) thumbs[cur].focus();
    });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (cur >= 0) track.scrollLeft = slides[cur].offsetLeft;
      }).observe(track);
    }

    mark(0);
    return go;
  }

  function initRoot(root) {
    if (root.getAttribute('data-vpdp-bound') === '1') return;
    root.setAttribute('data-vpdp-bound', '1');
    if (root.dataset.vpdpInit) return;
    root.dataset.vpdpInit = '1';

    var currency = root.dataset.currency || 'USD';
    var atcLabel = root.dataset.atcLabel || 'ADD TO CART';
    var atcAction = root.dataset.atcAction || 'cart';
    var fmt = function (n) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(Math.round(n));
      } catch (e) { return '$' + Math.round(n).toLocaleString(); }
    };

    var fmtAddon = function (n) {
      var hasCents = Math.abs(n - Math.round(n)) > 0.001;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: currency,
          minimumFractionDigits: hasCents ? 2 : 0,
          maximumFractionDigits: hasCents ? 2 : 0
        }).format(n);
      } catch (e) { return '$' + (hasCents ? n.toFixed(2) : String(Math.round(n))); }
    };

    var variants = [];
    var vEl = root.querySelector('[data-vpdp-variants]');
    if (vEl) { try { variants = JSON.parse(vEl.textContent) || []; } catch (e) { variants = []; } }
    function variantById(id) { for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; } return null; }

    var preorder = {};
    var poEl = root.querySelector('[data-vpdp-preorder]');
    if (poEl) {
      try {
        (JSON.parse(poEl.textContent) || []).forEach(function (r) { preorder[String(r.id)] = r; });
      } catch (e) { preorder = {}; }
    }
    function poFor(id) { return preorder[String(id)] || null; }

    var hidden = root.querySelector('[data-vpdp-variant-id]');
    var initial = (hidden && variantById(hidden.value)) || variants[0] || null;

    var state = {
      term: parseInt(root.dataset.defaultTerm, 10) || 12,
      priceCents: initial ? initial.price : (parseInt(root.dataset.priceCents, 10) || 0),
      variantId: initial ? initial.id : (hidden ? hidden.value : root.dataset.variantId),
      available: initial ? initial.available : true
    };

    function currentSelection() {
      var sel = [];
      root.querySelectorAll('.vpdp__swatches').forEach(function (g) {
        var a = g.querySelector('.vpdp__swatch.is-active');
        sel.push(a ? a.getAttribute('data-val') : null);
      });
      return sel;
    }
    function findVariant(sel) {
      if (!sel.length) return initial || variants[0] || null;
      return variants.find(function (v) {
        for (var i = 0; i < sel.length; i++) { if (sel[i] !== null && v.options[i] !== sel[i]) return false; }
        return true;
      }) || null;
    }

    function renderATC() {
      var btn = q(root, '[data-vpdp-atc]');
      if (!btn) return;
      var vpo = poFor(state.variantId);
      var label = vpo ? vpo.label : atcLabel;
      var btnCents = state.priceCents + (typeof addonsExtraCents === 'function' ? addonsExtraCents() : 0);
      if (state.available) { btn.disabled = false; btn.textContent = label + ' · ' + fmtAddon(btnCents / 100); }
      else { btn.disabled = true; btn.textContent = 'Sold out'; }
      qa(root, '.vpdp-atc').forEach(function (b) {
        var priceEl = b.querySelector('[data-vpdp-price]');
        if (priceEl) { priceEl.textContent = fmtAddon(btnCents / 100); priceEl.hidden = !state.available; }
        b.disabled = !state.available;
        var textNode = null;
        for (var i = 0; i < b.childNodes.length; i++) {
          var n = b.childNodes[i];
          if (n.nodeType === 3 && n.nodeValue.trim()) { textNode = n; break; }
        }
        if (!textNode) return;
        textNode.nodeValue = !state.available ? 'Sold out' : (priceEl ? (label + ' · ') : label);
      });
    }

    function renderPreorder() {
      var rec = poFor(state.variantId);
      var on = !!rec && state.available;

      var badge = q(root, '[data-vpdp-po-badge]');
      if (badge) {
        badge.hidden = !on;
        var etaEl = badge.querySelector('[data-vpdp-po-eta]');
        var msgEl = badge.querySelector('[data-vpdp-po-msg]');
        if (etaEl) { etaEl.textContent = on ? (rec.eta || '') : ''; etaEl.hidden = !(on && rec.eta); }
        if (msgEl) { msgEl.textContent = on ? (rec.msg || '') : ''; msgEl.hidden = !(on && rec.msg); }
        if (on && !rec.eta && !rec.msg) badge.hidden = true;
      }

      var instockEl = q(root, '[data-vpdp-instock]');
      if (instockEl) instockEl.hidden = on;
      document.querySelectorAll('.voro-urg__ship').forEach(function (el) {
        if (on) {
          if (el.getAttribute('data-vpo-hid') === null) {
            el.setAttribute('data-vpo-hid', el.style.display || '');
            el.style.display = 'none';
          }
        } else if (el.getAttribute('data-vpo-hid') !== null) {
          el.style.display = el.getAttribute('data-vpo-hid');
          el.removeAttribute('data-vpo-hid');
        }
      });

      var flag = q(root, '[data-vpdp-po-flag]');
      var noteEl = q(root, '[data-vpdp-po-note]');
      if (flag) { flag.disabled = !on; flag.value = on ? '1' : ''; }
      if (noteEl) { noteEl.disabled = !on; noteEl.value = on ? (rec.eta || 'Pre-order') : ''; }
    }

    function render() {
      var price = state.priceCents / 100;
      var monthly = state.term > 0 ? price / state.term : price;
      qa(root, '[data-vpdp-price]').forEach(function (el) { el.textContent = fmt(price); });
      qa(root, '[data-vpdp-monthly]').forEach(function (el) { el.textContent = fmt(monthly); });
      qa(root, '[data-vpdp-total]').forEach(function (el) { el.textContent = fmt(price); });
      qa(root, '[data-vpdp-term]').forEach(function (el) { el.textContent = state.term; });
      qa(root, '.vpdp__term').forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.dataset.term, 10) === state.term);
      });
      renderAddons();
    }

    function setVariant(v) {
      if (!v) return;
      state.variantId = v.id; state.priceCents = v.price; state.available = v.available;
      if (hidden) hidden.value = v.id;
      var was = q(root, '[data-vpdp-was]');
      var save = q(root, '[data-vpdp-save]');
      var badge = q(root, '[data-vpdp-badge]');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (was) { was.hidden = false; was.textContent = fmt(v.compare_at_price / 100); }
        if (save) { save.hidden = false; save.textContent = 'Save ' + fmt((v.compare_at_price - v.price) / 100); }
        if (badge) { badge.hidden = false; badge.textContent = 'Save ' + fmt((v.compare_at_price - v.price) / 100); }
      } else {
        if (was) was.hidden = true;
        if (save) save.hidden = true;
        if (badge) badge.hidden = true;
      }
      var instock = q(root, '[data-vpdp-instock]');
      if (instock) {
        var note = instock.getAttribute('data-vpdp-instock');
        instock.textContent = state.available ? (note || '') : 'Currently unavailable';
      }
      renderPreorder();
      render();
      if (galleryGo && v.featured_media) galleryGo(v.featured_media.position - 1);
      document.dispatchEvent(new CustomEvent('voro:variant', { detail: { id: v.id, price: v.price, available: v.available } }));
    }

    root.querySelectorAll('.vpdp__swatches').forEach(function (group, gi) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.vpdp__swatch'); if (!btn) return;
        group.querySelectorAll('.vpdp__swatch').forEach(function (s) { s.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var l = root.querySelector('[data-vpdp-optval="' + (gi + 1) + '"]');
        if (l) l.textContent = btn.getAttribute('data-val');
        setVariant(findVariant(currentSelection()));
      });
    });

    var gal = root.querySelector('[data-vpdp-gallery]');
    var galleryGo = gal ? bindGallery(gal) : null;
    if (galleryGo && initial && initial.featured_media &&
        new URLSearchParams(location.search).get('variant') === String(initial.id)) {
      galleryGo(initial.featured_media.position - 1);
    }

    qa(root, '.vpdp__term').forEach(function (btn) {
      btn.addEventListener('click', function () { state.term = parseInt(btn.dataset.term, 10); render(); });
    });

    var faq = q(root, '[data-vpdp-faq]');
    if (faq) {
      faq.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-faq-item]');
          var willOpen = !item.classList.contains('is-open');
          faq.querySelectorAll('[data-faq-item]').forEach(function (it) {
            it.classList.remove('is-open');
            var b = it.querySelector('[data-faq-toggle]');
            if (b) { b.setAttribute('aria-expanded', 'false'); b.querySelector('.vpdp__faq-sign').textContent = '+'; }
          });
          if (willOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            btn.querySelector('.vpdp__faq-sign').textContent = '–';
          }
        });
      });
    }

    var sticky = q(root, '[data-vpdp-sticky]');
    if (sticky) {
      var trigger = root.querySelector('.vpdp__hero') || root;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { rootMargin: '-120px 0px 0px 0px' });
        io.observe(trigger);
      } else {
        sticky.classList.add('is-visible');
      }
    }

    function selectedAddons() {
      var out = [];
      qa(root, '[data-vpdp-addon-input]').forEach(function (box) {
        var included = box.dataset.included === 'true';
        if (!included && !box.checked) return;
        var id = parseInt(box.value, 10);
        if (!id) return;
        var unit = parseInt(box.dataset.priceCents, 10) || 0;
        var qty = Math.max(1, parseInt(box.dataset.qty, 10) || 1);
        out.push({
          id: id,
          priceCents: unit,
          qty: qty,
          lineCents: unit * qty,
          free: box.dataset.free === 'true',
          productId: box.dataset.productId || '',
          title: box.dataset.title || ''
        });
      });
      return out;
    }

    function addonsExtraCents() {
      return selectedAddons().reduce(function (sum, a) {
        return a.free ? sum : sum + a.lineCents;
      }, 0);
    }

    function bikeSavingsCents() {
      var v = variantById(state.variantId);
      if (!v || !v.compare_at_price) return 0;
      var diff = v.compare_at_price - v.price;
      return diff > 0 ? diff : 0;
    }

    function giftSavingsCents() {
      return selectedAddons().reduce(function (s, a) { return a.free ? s + a.lineCents : s; }, 0);
    }

    function renderAddons() {
      var note = q(root, '[data-vpdp-addons-extra]');
      if (note) {
        var extra = addonsExtraCents();
        if (extra > 0) {
          var paid = selectedAddons().reduce(function (n, a) { return a.free ? n : n + a.qty; }, 0);
          note.textContent = '+ ' + fmtAddon(extra / 100) + ' in add-ons (' + paid + (paid === 1 ? ' item' : ' items') + ')';
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }

      var savingsEl = q(root, '[data-vpdp-savings]');
      if (savingsEl) {
        var gifts = giftSavingsCents();
        var total = bikeSavingsCents() + gifts;
        var amtEl = savingsEl.querySelector('[data-vpdp-savings-amt]');
        if (gifts > 0 && total > 0) {
          if (amtEl) amtEl.textContent = fmtAddon(total / 100);
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
      renderATC();
    }

    qa(root, '[data-vpdp-addon-input]').forEach(function (box) {
      box.addEventListener('change', renderAddons);
    });

    qa(root, '[data-vpdp-addon-variant]').forEach(function (sel) {
      sel.addEventListener('click', function (e) { e.stopPropagation(); });

      sel.addEventListener('change', function (e) {
        e.stopPropagation();
        var row = sel.closest('[data-vpdp-addon]');
        if (!row) return;
        var box = row.querySelector('[data-vpdp-addon-input]');
        var opt = sel.options[sel.selectedIndex];
        if (!box || !opt) return;

        box.value = opt.value;
        var cents = parseInt(opt.dataset.priceCents, 10) || 0;
        box.dataset.priceCents = cents;

        var rowCents = cents * Math.max(1, parseInt(box.dataset.qty, 10) || 1);
        var was = row.querySelector('[data-vpdp-addon-was]');
        var amt = row.querySelector('[data-vpdp-addon-amt]');
        if (was) was.textContent = fmtAddon(rowCents / 100);
        if (amt) amt.textContent = fmtAddon(rowCents / 100);

        renderAddons();
      });
    });

    function giftNote(gifts) {
      return gifts.map(function (g) {
        return (g.qty > 1 ? g.qty + ' \u00d7 ' : '') + g.title;
      }).join(', ');
    }

    function addToCart(btn) {
      if (!state.available) return;
      if (!state.variantId) { window.location.href = root.dataset.productUrl || '/'; return; }
      if (btn) btn.classList.add('is-loading');

      var item = { id: state.variantId, quantity: 1 };
      var props = {};
      var po = poFor(state.variantId);
      if (po) { props._preorder = '1'; props['Preorder'] = po.eta || 'Pre-order'; }

      var picked = selectedAddons();
      var gifts = picked.filter(function (a) { return a.free; });
      if (gifts.length) props[gifts.length > 1 ? 'Free gifts' : 'Free gift'] = giftNote(gifts);
      if (gifts.length || q(root, '[data-vpdp-gifts-offered]')) props._gifts_shown = gifts.length ? gifts.map(function (g) { return g.id; }).join(',') : 'none';
      if (Object.keys(props).length) item.properties = props;

      var items = [item];
      picked.forEach(function (a) {
        if (a.free) return;
        items.push({ id: a.id, quantity: a.qty });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (res.ok) return res.json();
        return addBikeThenGiftsBestEffort(item, items.slice(1));
      })
        .then(function () {
          document.dispatchEvent(new CustomEvent('voro:cart:added', { detail: { id: state.variantId } }));
          if (atcAction === 'checkout') { window.location.href = '/checkout'; }
          else if (atcAction === 'cart' && !drawerOpensOnAdd()) { window.location.href = '/cart'; }
          else { if (btn) btn.classList.remove('is-loading'); }
        })
        .catch(function () {
          if (btn) btn.classList.remove('is-loading');
          window.location.href = root.dataset.productUrl || '/';
        });
    }

    function addBikeThenGiftsBestEffort(bike, extras) {
      var post = function (line) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [line] })
        });
      };
      return post(bike).then(function (res) {
        if (!res.ok) throw new Error('bike add failed');
        return extras.reduce(function (chain, line) {
          return chain.then(function () {
            return post(line).catch(function () {});
          });
        }, Promise.resolve());
      });
    }

    var form = q(root, '#vpdp-product-form') || q(root, '.vpdp__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(q(root, '[data-vpdp-atc]'));
      });
    }
    qa(root, '.vpdp-atc').forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn); });
    });

    renderPreorder();
    renderAddons();
    render();
  }

  function init() {
    document.querySelectorAll('[data-vpdp-root]').forEach(initRoot);
    bindRatingLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  var els = document.querySelectorAll('[data-vpm]');
  if (!els.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(els, function (el) {
    var track = el.querySelector('.vpm__track');
    var arc = el.querySelector('[data-vpm-arc]');
    var peakEl = el.querySelector('[data-vpm-peak]');
    var ratedEl = el.querySelector('[data-vpm-rated]');
    var gainEl = el.querySelector('[data-vpm-gain]');
    if (!track) return;

    var fromPeak = parseFloat(el.dataset.fromPeak) || 0;
    var toPeak = parseFloat(el.dataset.toPeak) || 0;
    var fromRated = parseFloat(el.dataset.fromRated) || 0;
    var toRated = parseFloat(el.dataset.toRated) || 0;
    var scaleMax = parseFloat(el.dataset.scale) || 20;

    var CIRC = 2 * Math.PI * 132;
    var SWEEP = 0.75;
    if (arc) arc.style.strokeDasharray = CIRC;

    function paint(t) {
      el.style.setProperty('--t', t.toFixed(4));

      var peak = fromPeak + (toPeak - fromPeak) * t;
      var rated = fromRated + (toRated - fromRated) * t;

      if (peakEl) peakEl.textContent = peak.toFixed(1);
      if (ratedEl) ratedEl.textContent = String(Math.round(rated));
      if (gainEl && fromPeak > 0) {
        gainEl.textContent = (((peak - fromPeak) / fromPeak) * 100).toFixed(1);
      }
      if (arc) {
        var frac = Math.max(0, Math.min(1, peak / scaleMax)) * SWEEP;
        arc.style.strokeDashoffset = CIRC * (1 - frac);
      }
    }

    if (reduce) {
      el.classList.add('is-static');
      paint(1);
      return;
    }

    var ticking = false;
    function update() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var stage = el.querySelector('.vpm__stage');
      var stageH = stage ? stage.offsetHeight : window.innerHeight;
      var travel = r.height - stageH;
      if (travel <= 0) { paint(1); return; }
      var t = (-r.top) / travel;
      paint(Math.max(0, Math.min(1, t)));
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', onScroll);
    update();
  });
})();

(function () {
  if (window.voroChatDodge) return;

  var CLS = 'vpdp-chat-dodge';
  var TAP = '.vpdp button, .vpdp a, .vpdp input, .vpdp select, .vpdp label, .vpdp [role="button"]';
  var TEXT = '.vpdp .vpdp__badge, .vpdp .vpdp__badge-corner, .vpdp .vpdp__eyebrow,'
    + '.vpdp .vpdp__final-title, .vpdp .vpdp__faq-item.is-open .vpdp__faq-a p';
  var SEEN = 'data-vcd';
  var PAD = 8;

  var all = [];
  var onScreen = [];
  var holds = {};
  var raf = 0;

  var io = window.IntersectionObserver ? new window.IntersectionObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var el = recs[i].target, at = onScreen.indexOf(el);
      if (recs[i].isIntersecting) { if (at < 0) onScreen.push(el); }
      else if (at > -1) onScreen.splice(at, 1);
    }
    queue();
  }) : null;

  function collect() {
    var els = document.querySelectorAll(TAP + ', ' + TEXT);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute(SEEN) || (el.closest && el.closest('[class*="jdgm"]'))) continue;
      el.setAttribute(SEEN, '1');
      all.push(el);
      if (io) io.observe(el);
    }
  }

  function launcher() {
    var c = document.getElementById('chatra');
    if (!c || /chatra--expanded/.test(c.className || '')) return null;
    var b = c.getBoundingClientRect();
    if (b.width <= 0 || b.height <= 0 || b.height > 120) return null;
    return b;
  }

  function covers(b) {
    var list = onScreen.length ? onScreen : all;
    for (var i = 0; i < list.length; i++) {
      var a = list[i].getBoundingClientRect();
      if (a.width <= 0 || a.height <= 0) continue;
      if (a.left < b.right && a.right > b.left && a.top < b.bottom + PAD && a.bottom > b.top - PAD) return true;
    }
    return false;
  }

  function anyHold() {
    for (var k in holds) { if (holds[k]) return true; }
    return false;
  }

  function check() {
    raf = 0;
    var b = launcher();
    document.documentElement.classList.toggle(CLS, !!b && (anyHold() || covers(b)));
  }
  function queue() { if (!raf) raf = window.requestAnimationFrame(check); }
  function rescan() { collect(); queue(); }

  window.voroChatDodge = {
    check: queue,
    hold: function (on, key) {
      key = key || 'default';
      if (!holds[key] === !on) return;
      holds[key] = !!on;
      queue();
    }
  };

  collect();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', rescan);
  document.addEventListener('click', function () { setTimeout(rescan, 350); }, true);
  document.addEventListener('shopify:section:load', rescan);
  [800, 2500, 6000].forEach(function (ms) { setTimeout(rescan, ms); });
})();

(function () {
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(v) { return v * v * (3 - 2 * v); }
  var storyN = 0;

  function init(root) {
    var els = root.querySelectorAll('[data-vstory]');
    Array.prototype.forEach.call(els, function (el) {
      if (el._vst) return;
      var dodgeKey = 'vstory' + (++storyN);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var chs = el.querySelectorAll('[data-vst-ch]');
      var track = el.querySelector('.vst__track');
      if (reduce || chs.length < 2 || !track) return;
      el._vst = true;

      var n = chs.length;
      var ch = Array.prototype.map.call(chs, function (c, i) {
        var media = c.querySelector('[data-vst-media]');
        media.style.zIndex = String(i + 1);
        return {
          media: media,
          img: c.querySelector('.vst__img'),
          cap: c.querySelector('[data-vst-cap]'),
          move: c.getAttribute('data-move') === 'pull' ? 'pull' : 'push'
        };
      });
      var steps = el.querySelectorAll('[data-vst-step]');
      var fills = el.querySelectorAll('[data-vst-fill]');
      el.classList.add('is-live');

      function paint(t) {
        var u = t * n - 0.5;
        var p = [];
        for (var k = 0; k < n - 1; k++) p.push(ease(clamp((u - k - 0.25) / 0.5)));
        var active = 0;
        for (var i = 0; i < n; i++) {
          var pin = i > 0 ? p[i - 1] : 1;
          var pout = i < n - 1 ? p[i] : 0;
          var c = ch[i];
          var nextMove = i < n - 1 ? ch[i + 1].move : 'push';

          var op = i === 0 ? 1 : clamp((pin - (c.move === 'push' ? 0.3 : 0.15)) / 0.55);
          if (pout >= 1) op = 0;
          c.media.style.opacity = op;
          c.media.style.visibility = op > 0 ? 'visible' : 'hidden';

          var s = 1;
          if (i > 0) s *= c.move === 'push' ? 1.06 - 0.06 * pin : 1.14 - 0.14 * pin;
          if (pout > 0) s *= nextMove === 'push' ? 1 + 1.8 * pout : 1 - 0.1 * pout;
          c.img.style.transform = s === 1 ? '' : 'scale(' + s.toFixed(4) + ')';

          var cin = i === 0 ? 1 : clamp((pin - 0.5) / 0.5);
          var cout = clamp(1 - pout / 0.5);
          var co = Math.min(cin, cout);
          c.cap.style.opacity = co;
          c.cap.style.visibility = co > 0 ? 'visible' : 'hidden';
          c.cap.style.transform = 'translateY(' + ((1 - cin) * 10 - (1 - cout) * 10).toFixed(2) + 'px)';

          if (pin >= 0.5 && pout < 0.5) active = i;
          if (fills[i]) fills[i].style.transform = 'scaleX(' + pin.toFixed(3) + ')';
        }
        for (var j = 0; j < steps.length; j++) steps[j].classList.toggle('is-on', j === active);
      }

      var ticking = false;
      function update() {
        ticking = false;
        var r = track.getBoundingClientRect();
        var stage = el.querySelector('.vst__stage');
        var stageH = stage ? stage.offsetHeight : window.innerHeight;
        if (window.voroChatDodge) {
          window.voroChatDodge.hold(r.top < stageH * 0.5 && r.bottom > stageH * 0.5, dodgeKey);
        }
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var travel = r.height - stageH;
        if (travel <= 0) { paint(1); return; }
        paint(clamp(-r.top / travel));
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }
      paint(0);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', onScroll);
      update();
    });
  }

  // YouTube posters (snippets/vpdp-yt): the real player is only built when the rider presses
  // play, so a page with three videos no longer boots three players on scroll. Delegated, so
  // it also covers sections the Theme Editor re-renders. This block is not behind the
  // __voroPdpLoaded guard and every vpdp section loads this file, so bind the listener once.
  if (!window.__voroPdpYtBound) document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vpdp-yt]');
    if (!btn || !btn.parentNode) return;
    var frame = document.createElement('iframe');
    frame.src = btn.getAttribute('data-vpdp-yt');
    frame.title = btn.getAttribute('data-title') || 'Video';
    frame.setAttribute('frameborder', '0');
    frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
    frame.setAttribute('allowfullscreen', '');
    btn.parentNode.replaceChild(frame, btn);
    try { frame.focus({ preventScroll: true }); } catch (err) {}
  });
  window.__voroPdpYtBound = true;

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
